import React from 'react'
import Centered from 'shared/ui/Centered'
import { NewsletterSubscribeSection } from '../ui/NewsletterSubscribeForm'

export default function Newsletter() {
  return (
    <Centered>
      <br />
      <br />
      <NewsletterSubscribeSection focus />
    </Centered>
  )
}
